// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__e_CP5","col":"styles_col__108U4"};